import { useTheme } from '@/providers/theme-provider';
import { Card, CardContent, CardHeader } from '@/components/ui/card';
import React from 'react';

export default function AuthLayout({ children }: { children: React.ReactNode }) {
  const { logo } = useTheme();
  return (
    <div className=" md:bg-background mx-auto h-dvh w-full flex flex-col justify-center items-center">
      <Card className="w-full max-w-lg">
        <CardHeader className="space-y-2 text-center">
          <div className="flex justify-center mb-4">
            <img src={logo} alt="rise logo" width={100} height={100} />
          </div>
        </CardHeader>
        <CardContent>{children}</CardContent>
      </Card>
    </div>
  );
}
